import type { LinkTextProps } from '@/types/components/link-text'
import { Link } from './Link'
import type React from 'react'

export const LinkText: React.FC<LinkTextProps> = ({
  link,
  className = '',
  reverse = false,
}) => {
  const { text } = link

  const classes = ['link', { 'link-reverse': reverse }, className]

  return (
    <Link link={link} classes={classes}>
      {text}
    </Link>
  )
}
